import gql from 'graphql-tag';
import { useMutation } from '@vue/apollo-composable';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import baseConfig from '@/config/base.config';
import dateUtils from '@/utils/date.utils'



const { profileInfo } = useProfileInfo();

// graphql - 热图设置
const SET_HEATMAP_MUTATION = gql`
    mutation setHeatMapWithToken($input: SetHeatMapInput!) {
        setHeatMapWithToken(input: $input)
    }
`;

// graphql - 新热图设置
const SET_MULTI_HEATMAP_WITH_TOKEN = gql`
    mutation setMultiHeatMapWithToken($token: String!, $configList: [SetHeatMapInput!]!) {
        setMultiHeatMapWithToken(token: $token, configList: $configList)
    }
`;

export function addProtocol(url: string): string {
    const reg = /^(http|https:\/\/)/;
    return url !== '' && !reg.test(url) ? `http://${url}` : url;
}

/**
 * 热图设置
 */
export function setHeatMap(option: any, token: string) {
    const { mutate: setHeatMapWithToken } = useMutation(SET_HEATMAP_MUTATION);
    const { startTimeStr, endTimeStr } = option.dataParameter || {}; //pti 传输的是时间字符串

    option.dataParameter.timeZone = profileInfo.value?.timeZone;
    option.pageInfo.authType = baseConfig.HEATMAP_DEFAULT_SHARE_AUTH_TYPE;
    option.pageInfo.profileName = profileInfo.value?.name;

    // pti日历时间已经是按档案时区处理后的结果
    if (startTimeStr) {
        option.dataParameter.startTime = dateUtils.parsingInZone(`${startTimeStr} 00:00:00`, option.dataParameter.timeZone).valueOf();
        delete option.dataParameter.startTimeStr;
    }
    if (endTimeStr) {
        option.dataParameter.endTime = dateUtils.parsingInZone(`${endTimeStr} 23:59:59`, option.dataParameter.timeZone).valueOf();
        delete option.dataParameter.endTimeStr;
    }

    const SetHeatMapInput = {
        token,
        config: option
    };
    return setHeatMapWithToken({ input: SetHeatMapInput })
        .then((result: any) => {
            return result.data.setHeatMapWithToken;
        })
        .catch((err: any) => {
            return false;
        });
}

/**
 * 新热图设置
 */
export function setMultiHeatMapData(configList: any, token: string) {
    const { mutate: setMultiHeatMapWithToken } = useMutation(SET_MULTI_HEATMAP_WITH_TOKEN);
    return setMultiHeatMapWithToken({ configList: configList, token: token })
        .then((result: any) => {
            return result.data.setMultiHeatMapWithToken;
        })
        .catch((err: any) => {
            return false;
        });
}
